import React from 'react';
import { Link } from 'react-router-dom';
import Styles from './table-item-link-styles.scss';
const TableItemLink = ({ to, text }) => {
    return (React.createElement(Link, { className: Styles.linkWrap, to: to },
        React.createElement("span", { className: Styles.link }, text)));
};
export default TableItemLink;
